import { ref, unref, watch } from 'vue';
import { useResizeObserver } from './useResizeObserver';
import { useEventListener } from './useEventListener';
import fastdom from 'fastdom';

export const useElRect = (elMaybeRef) => {

    const top = ref(0);
    const bottom = ref(0);
    const left = ref(0);
    const right = ref(0);
    const width = ref(0);
    const height = ref(0);

    const update = () => {
        const el = unref(elMaybeRef);
        if (!el) return;

        fastdom.measure(() => {
            const rect = el.getBoundingClientRect();
            top.value = rect.top;
            bottom.value = rect.bottom;
            left.value = rect.left;
            right.value = rect.right;
            width.value = rect.width;
            height.value = rect.height;
        });
    };

    update();

    watch(() => unref(elMaybeRef), () => {
        update();
    }, { flush: 'sync' });

    // eslint-disable-next-line no-console
    useResizeObserver(elMaybeRef, update);
    useEventListener('mousewheel', update, { passive: true });
    useEventListener('scroll', update, { passive: true });
    useEventListener('touchmove', update, { passive: true });
    useEventListener('resize', update, { passive: true });
    useEventListener('transitionend', update, { passive: true });

    return {
        width,
        height,
        top,
        bottom,
        right,
        left,
        update,
    };
};
